<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
          <span class="title-content">
            <text-lang :lang="lang">
              <template slot="es">Portal de Información para Accionistas</template>
              <template slot="en">Shareholder Relations</template>
            </text-lang>
          </span>
        </div>
      </template>
    </parallax>

    <section class="light-content light-content-secondary">
      <div class="container">
        <box-container size="1">
          <box padding="20px">
            <p class="title-content">
              <text-lang :lang="lang">
                <template slot="es">Anuncios Importantes</template>
                <template slot="en">Important Announcements </template>
              </text-lang>
            </p>
            <div class="title-content title-content-small">
              <text-lang :lang="lang">
                <template slot="es">{{ ad.title.es }}</template>
                <template slot="en">{{ ad.title.en }}</template>
              </text-lang>
            </div>
            <p class="title-content title-content-tertiary title-content-small" style="font-weight: lighter">{{ad.date}}</p>
            <span class="text text-secondary">
              <text-lang :lang="lang">
                <template slot="es">{{ ad.content.es }}</template>
                <template slot="en">{{ ad.content.en }}</template>
              </text-lang>
            </span>
          </box>
        </box-container>
        <box-container size="2" style="margin-top: 20px">
          <box padding="20px">
            <list-content>
              <list-content-item>
                <p class="title-content">
                  <text-lang :lang="lang">
                    <template slot="es">Cotización de Acción</template>
                    <template slot="en">Stock Quote</template>
                  </text-lang>
                </p>
                <p class="text text-secondary">
                  <text-lang :lang="lang">
                    <template slot="es">Información sobre la cotización y el rendimiento de la acción de CrecePymes</template>
                    <template slot="en">Take a look at our share information and historic performance</template>
                  </text-lang>
                </p>
              </list-content-item>
              <list-content-item>
                <div class="title-content title-content-big">ICP.B</div>
                <div v-if="!bvc.loading && !bvc.error">
                  <div class="text text-primary"><span>{{bvc.data.price | numberFormat }}</span> BsS</div>
                </div>
                <div v-else-if="!bvc.loading && bvc.error">
                  <span style="font-weight: lighter">
                    <text-lang :lang="lang">
                      <template slot="es">Intente nuevamente...</template>
                      <template slot="en">Try again...</template>
                    </text-lang>
                  </span>
                </div>
                <div v-else>
                  <span style="font-weight: lighter">
                    <text-lang :lang="lang">
                      <template slot="es">Cargando información de la BVC...</template>
                      <template slot="en">Loading BVC information ...</template>
                    </text-lang>
                  </span>
                </div>
                <p class="text text-tertiary">
                  <text-lang :lang="lang">
                    <template slot="es">Precio</template>
                    <template slot="en">Quote</template>
                  </text-lang>
                </p>

                <router-link class="button" :to="{name: 'StockQuote'}">
                  <text-lang :lang="lang">
                    <template slot="es">Detalle</template>
                    <template slot="en">Details</template>
                  </text-lang>
                </router-link>
              </list-content-item>
            </list-content>
          </box>
          <box padding="20px">
            <list-content>
              <list-content-item>
                <p class="title-content">
                  <text-lang :lang="lang">
                    <template slot="es">Reportes</template>
                    <template slot="en">Reports</template>
                  </text-lang>
                </p>
                <p class="text text-secondary">
                  <text-lang :lang="lang">
                    <template slot="es">Acceso a Histórico de reportes a SUNAVAL y documentos constitutivos de la empresa</template>
                    <template slot="en">Have access to the most recent and historic corporate filings to SUNAVAL</template>
                  </text-lang>
                </p>
              </list-content-item>
              <list-content-item>
                <list-content class="list-content-download">
                  <list-content-item v-for="(file,index) in sunaval" :key="index" style="border: none">
                    <file-download :file="{label: file.label, path:`./documents/SUNAVAL/${file.nameFile}`}" marginRightIcon="0px" />
                  </list-content-item>
                </list-content>

                <router-link class="button" :to="{name: 'SunavalFilings'}">
                  <text-lang :lang="lang">
                    <template slot="es">Ver todos</template>
                    <template slot="en">See all</template>
                  </text-lang>
                </router-link>
              </list-content-item>
            </list-content>
          </box>
        </box-container>
      </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import BoxContainer from '@/components/BoxContainer.vue'
import Box from '@/components/Box.vue'
import TextLang from '@/components/TextLang.vue'
import FileDownload from '@/components/FileDownload'
import sunaval from '@/reports_sunaval.js'
import ad from '@/ad.js'

export default {
  name: 'ShareholderRelations',
  props: ['lang', 'bvc'],
  components: {
    Parallax,
    ListContent,
    ListContentItem,
    BoxContainer,
    Box,
    TextLang,
    FileDownload
  },
  data() {
    return {
      sunaval: sunaval.slice(0, 2),
      ad: ad
    }
  }
}
</script>
